import React from 'react';
import { useSearchParams } from 'react-router-dom';


interface Status {
  value: string;
  label: string;
}

interface StatusBarProps {
  statusList: Status[];
  currentStatus?: string | null;
  onChangeStatus?: (status: string) => void;
  buttonLabel?: string;
  onButtonClick?: () => void;
  fieldName?: string;
}

const StatusBar: React.FC<StatusBarProps> = ({
  statusList,
  currentStatus,
  onChangeStatus,
  buttonLabel,
  onButtonClick,
  fieldName = 'status',
}) => {

  const onButtonClickHandle = (e:any) => {
    e.preventDefault();
    onButtonClick?.()
  };

  const [searchParams, setSearchParams] = useSearchParams()


  const changeStatus = (status: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(fieldName, status);
    newParams.set("page", "1"); 
    // remove after and before of graphql pagination
    newParams.delete("after");
    newParams.delete("before");
    setSearchParams(newParams);
  };

  const currentStatusDefault = searchParams.get(fieldName) || '';


  return (
    <div className="text-base-300 flex flex-col-reverse xl:flex-row xl:items-center gap-4 xl:justify-center border-b border-[#EEEFF2] py-5 px-10 pb-3 w-[100%]">
      {statusList.length > 0 &&
      <div className="flex gap-3 xl:gap-5 pb-2 mh:pb-0 overflow-hidden overflow-x-auto w-100">
        <a
          onClick={() => onChangeStatus ? onChangeStatus('') : changeStatus('')}
          className={`relative text-sm md:text-[16px] cursor-pointer ${currentStatusDefault === '' && ('pb-2 border-b-2 border-[#0CAF60]')} ${
            currentStatusDefault === '' ? "text-[#0CAF60] font-bold" : ""
          }`}
        >
          All
          
        </a>

        {statusList.map((status) => (
          <a
            key={status.value}
            onClick={() => onChangeStatus ? onChangeStatus(status.value) : changeStatus(status.value)}
            className={`relative text-sm md:text-[16px] cursor-pointer  ${currentStatusDefault === status.value && ('pb-2 border-b-2 border-[#0CAF60]')} ${
              currentStatusDefault === status.value ? "text-[#0CAF60] font-bold" : ""
            }`}
          >
            {status.label}
            {currentStatusDefault === status.value && (
              <span className=" border-b-2 border-[#0CAF60]"></span>
            )}
          </a>
        ))}
      </div>}

      {buttonLabel && (
        <button
          onClick={onButtonClickHandle}
          className="ml-auto px-4 py-2 bg-[#0CAF60] text-white rounded-md hover:bg-[#0A9D54] text-nowrap"
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

export default StatusBar;
